import axios from "src/lib/axios";
import UserGroupPageMappingType from "./Types/MenuAndSubmenuType";

const API_URLS = {
    GET_PAGES: `/Users/GetAllUsers`,
    GET_MENUS: `/Widget/GetPageGroupsAndPagesForWidget`,
    GET_APP_MENUS: '/MenuAndSubMenu/GetAllMenuMappingsForAppKey',
    GET_PAGE_MAPPING_FOR_WIDGET: '/Widget/GetWidgetPageMappingForWidget'
};

export const GetAllPages = async () => {
    const pageData = await axios.get(API_URLS.GET_PAGES);
    return pageData?.data || [];
  };

  export const getWebMethodsList = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetWebMethodsList'
    );
    return response?.data;
  };
  
  export const getPageGroupsList = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/MenuAndSubMenu/GetPageGroups'
    );
    return response?.data;
  };
  
  export const getPagesList = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/MenuAndSubMenu/GetPages'
    );
    return response?.data;
  };

  export const getWidgets = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/Widget/GetWidgetList'
    );
    return response?.data;
  };

  export const getConfigUserGroupRoleWithPermissions = async (configUserGroupKey): Promise<any> => {
    const response = await axios.get<any[]>(
        `/ConfigAccount/GetConfigUserGroupRoleWithPermissions?ConfigUserGroupKey=${configUserGroupKey}`
    );
    return response.data;
  };

  export const getWidgetCategories = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/Widget/GetWidgetCategoryMaster'
    );
    return response?.data;
  };

  export const getFieldTypes = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/Widget/GetFieldDataTypeMaster'
    );
    return response?.data;
  };

  export const getFieldDataTypeFormat = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/Widget/GetFieldDataTypeFormatMaster'
    );
    return response?.data;
  };

  export const getResponseParams = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetWebMethodResponseParams'
    );
    return response?.data;
  };

  export const insertUpdateWidgetDetails = async (data: any): Promise<any> => {
    const response = await axios.post<any>(
      `/Widget/InsertUpdateWidget`,
      data
    );
    return response.data;
  };
  export const getCategoryList = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      `/Widget/GetWidgetCategoryMaster`
    );
    return response?.data;
  };
  export const getWidgetTypes = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      `/Widget/GetWidgetTypeMaster`
    );
    return response?.data;
  };



  export const getWidgetByKey = async (widgetKey): Promise<any> => {
    const response = await axios.get<any[]>(
      `/Widget/GetWidgetsByKey?widgetKey=${widgetKey}`
    );
    return response?.data;
  };

  export const UpdateEnableStatus = async (WidgetKey: string, IsEnabled: boolean, UserKey: string) => {
      const res = await axios.put(`/Widget/EnableDisableWidgets?WidgetKey=${WidgetKey}&IsEnabled=${IsEnabled}&UserKey=${UserKey}`);
      return res?.data;
  }

  export const deleteWidget = async (widgetKey): Promise<any> => {
    const response = await axios.post<any>(
      `/Widget/DeleteWidgets/${widgetKey}`
    );
    return response?.data;
  };
  
export const getUserGroups = async (userEmail): Promise<any> => {
  const response = await axios.get<any[]>(
    `/InvestApp/GetUserGroups/${userEmail}`
  );
  return response?.data;
};

export const GetPageGroupsAndPages = async (widgetKey: string) => {
  try
  {
    const pageGroupAndPage = await axios.get<string[]>(API_URLS.GET_MENUS, { params: { widgetKey }});
    return pageGroupAndPage.data || [];
  } catch {
    return [];
  }
};

export const GetAppMenusAndSubmenusWithUserGroup = async () => {
  try {
    const menus = await axios.get<UserGroupPageMappingType[]>(API_URLS.GET_APP_MENUS);
    return menus.data || [];
  } catch {
    return [];
  }
};

export const GetWidgetPageMappingForWidget = async (widgetKey: string) => {
  try {
    const pageMappingResponse = await axios.get(API_URLS.GET_PAGE_MAPPING_FOR_WIDGET, { params: { widgetKey }});
    return pageMappingResponse.data || [];
  } catch {
    return [];
  }
};

export const getCustomWidgetFieldTypeMaster = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    '/Widget/GetCustomWidgetFieldTypeMaster'
  );
  return response?.data;
};